import {
  OptimizelyProvider,
  createInstance,
  logOnlyEventDispatcher,
} from '@optimizely/react-sdk'

import { useAuthToken } from '@tribeplatform/react-sdk/hooks'

import { RuntimeConfigs } from '../../config'

export const Optimizely = ({ children, datafile }) => {
  const isServer = typeof window === 'undefined'
  const { data: authToken } = useAuthToken()

  const optimizely = createInstance({
    datafile,
    sdkKey: RuntimeConfigs.OPTIMIZELY_SDK_KEY,
    logLevel: 'error',
    eventDispatcher:
      !isServer &&
      RuntimeConfigs.NODE_ENV === 'development' &&
      logOnlyEventDispatcher,
  })

  return (
    <OptimizelyProvider
      optimizely={optimizely}
      isServerSide={isServer}
      user={{
        id: authToken?.member?.id || '',
        attributes: {
          // Passing null/undefined values to these keys will cause the feature flag break
          email: String(authToken?.member?.email),
          username: String(authToken?.member?.username),
          name: String(authToken?.member?.name),
          roleType: String(authToken?.member?.role?.type),
          communityId: String(authToken?.networkPublicInfo?.id),
        },
      }}
    >
      {children}
    </OptimizelyProvider>
  )
}
